/**
 * PDP móvil: carrusel bajo `.product-gallery-carousel.mobile-only`.
 * Swiper 11 (theme.liquid). Tras cambio de producto por swatch agrupado, la galería se
 * reemplaza por AJAX (innerHTML) sin `shopify:section:load` — llamar `window.lopReinitPdpMobileGallery`
 * desde ese flujo (product.js / color-switcher.js).
 */
(function () {
  var syncFeaturedByTrack = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function featuredMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id != null) {
      return String(variant.featured_media.id);
    }
    if (variant.featured_image && variant.featured_image.id != null) {
      return String(variant.featured_image.id);
    }
    return null;
  }

  function setupContainer(container) {
    var track = container.querySelector('.product-carousel-track');
    if (!track || track.children.length < 2) return;
    if (typeof Swiper === 'undefined') return;

    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    var dotsRoot = container.querySelector('.product-carousel-dots');
    var dots = dotsRoot ? dotsRoot.querySelectorAll('.carousel-dot') : [];

    if (dotsRoot && !dotsRoot.dataset.lopPdpDotsDelegated) {
      dotsRoot.dataset.lopPdpDotsDelegated = 'true';
      dotsRoot.addEventListener('click', function (ev) {
        var dot = ev.target.closest('.carousel-dot');
        if (!dot || !dotsRoot.contains(dot)) return;
        var s = container.swiper;
        if (!s) return;
        var idx = parseInt(dot.getAttribute('data-slide'), 10);
        if (isNaN(idx)) return;
        s.slideTo(idx);
      });
    }

    var swiper = new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 300,
      threshold: 5,
      touchRatio: 1,
      simulateTouch: true,
      allowTouchMove: true,
      resistanceRatio: 0.85,
      nested: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
    });

    function syncDots() {
      var i = swiper.activeIndex;
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('active', d === i);
      }
    }

    swiper.on('slideChange', syncDots);

    function goToMediaId(mediaId) {
      if (mediaId == null || mediaId === '') return;
      var slides = Array.prototype.slice.call(track.children);
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-shopify-media-id') || '') === String(mediaId)) {
          swiper.slideTo(i, 0);
          break;
        }
      }
    }

    if (syncFeaturedByTrack) {
      syncFeaturedByTrack.set(track, goToMediaId);
    }

    syncDots();
  }

  document.addEventListener('product:variant-change', function (ev) {
    var variant = ev.detail && ev.detail.variant;
    var id = featuredMediaId(variant);
    if (id == null || id === '' || !syncFeaturedByTrack) return;
    document.querySelectorAll('.product-gallery-carousel.mobile-only .product-carousel-track').forEach(function (track) {
      var fn = syncFeaturedByTrack.get(track);
      if (typeof fn === 'function') fn(id);
    });
  });

  function boot() {
    if (typeof Swiper === 'undefined') return;
    document.querySelectorAll('.product-gallery-carousel.mobile-only .product-carousel-container').forEach(setupContainer);
  }

  function bootWhenSwiper() {
    if (typeof Swiper !== 'undefined') {
      boot();
      return;
    }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (typeof Swiper !== 'undefined') {
        clearInterval(t);
        boot();
      } else if (tries > 100) {
        clearInterval(t);
      }
    }, 50);
  }

  function reinitPdpMobileGallery() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        bootWhenSwiper();
      });
    });
  }

  window.lopReinitPdpMobileGallery = reinitPdpMobileGallery;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWhenSwiper);
  } else {
    bootWhenSwiper();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || typeof ev.target.querySelector !== 'function') return;
    if (!ev.target.querySelector('.product-gallery-carousel.mobile-only')) return;
    bootWhenSwiper();
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev.target || typeof ev.target.querySelector !== 'function') return;
    ev.target.querySelectorAll('.product-gallery-carousel.mobile-only .product-carousel-container').forEach(function (c) {
      if (c.swiper) c.swiper.destroy(true, true);
    });
  });
})();
